import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchSalesChannel, fetchSettings, editSettings, deleteSalesChannel, fetchGlobalSettings, editSalesChannel, clearSalesChannelsErrors } from '../actions/'; // eslint-disable-line max-len
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditSalesChannel from '../components/salesChannels/EditSalesChannel';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  salesChannel: PropTypes.any,
  salesChannels: PropTypes.object,
  settings: PropTypes.any,
  globalSettings: PropTypes.any,
  salesChannelId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object,
};

class SalesChannelEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      error: false,
      globalSettings: {
      },
      settings: {
        clientLogo: '',
        heroImg: '',
        showNavbar: true,
        showHero: true,
        showFooter: true,
        theme: 'default',
        layout: 'default',
      },
      controls: {
        passcodeDisabled: true,
        requirePasscodeDisabled: true,
        storeDeviceDisabled: true,
        allowPaymentDisabled: true,
      },
      required: {
        campaignId: null,
        name: null,
        displayName: null,
        passcode: null,
        classification: null,
        subdomain: null,
        taxRate: null,
        paymentProcessorId: null,
      },
      salesChannel: {
        id: 0,
        name: '',
        displayName: '',
        allowPickup: null,
        allowShip: null,
        catalogId: 0,
        disabled: false,
        priceListId: 0,
        store: false,
        subdomain: '',
        taxRate: 0,
        classification: '',
        storeDevice: false,
        passcodeRequired: false,
        passcode: '',
        fulfillmentLocationId: 0,
        campaignId: '',
        allowPromos: false,
        allowPayAtStore: false,
        allowPayment: false,
        paymentProcessorId: 0,
        capturePayment: false,
        allowGiftCard: false,
        startDate: '',
        endDate: '',
        debugMode: false,
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchSalesChannel(this.props.salesChannelId));
    this.props.dispatch(fetchSettings(this.props.salesChannelId));
    this.props.dispatch(fetchGlobalSettings());
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.salesChannel && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Sales channel edited succesfully!',
        error: false,
      });
    }
  }
  deleteSalesChannel(scId) {
    const salesChannels = this.props.salesChannels;
    salesChannels.delete = true;
    this.setState({ salesChannels });
    this.props.dispatch(deleteSalesChannel(scId));
    browserHistory.push('/saleschannels?page=1');
  }
  saveEditSalesChannel(salesChannel) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editSettings(this.props.settings));
    this.props.dispatch(editSalesChannel(salesChannel));
  }
  navigateToView(saleschannel) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editSalesChannel(saleschannel));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearSalesChannelsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/saleschannels/view/${this.props.salesChannel.id}`);
      } else {
        browserHistory.push('/saleschannels?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="sales-channels component" style={authPage}>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <EditSalesChannel
          salesChannel={this.props.salesChannel}
          settings={this.props.settings}
          globalSettings={this.props.globalSettings}
          onSave={data => this.saveEditSalesChannel(data)}
          onDelete={data => this.deleteSalesChannel(data)}
          onView={data => this.navigateToView(data)}
        />
      </div>
    );
  }
}

SalesChannelEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

SalesChannelEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    salesChannel: state.salesChannels.salesChannel,
    salesChannels: state.salesChannels,
    settings: state.settings.data,
    globalSettings: state.globalSettings.data,
    salesChannelId: ownProps.params.id,
    error: state.salesChannels.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(SalesChannelEditPage));



// WEBPACK FOOTER //
// ./src/containers/SalesChannelEditPage.js